import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/account';

export class AccountService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  fetchAccounts(params: types.FetchAccountsParameters): Promise<types.FetchAccountResponse> {
    throw new Error('Method not implemented.');
  }
  createAccount(params: types.CreateAccountParameters): Promise<types.CreateAccountResponse> {
    throw new Error('Method not implemented.');
  }
}
